var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup335762(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 68,
    viewBox: "0 0 81 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 68,
    fill: "#7399EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 46.6667H27.6667C27.4882 46.6667 27.3333 46.5119 27.3333 46.3334C27.3333 46.1549 27.4882 46 27.6667 46H54.3333C54.5118 46 54.6667 46.1549 54.6667 46.3334C54.6667 46.5119 54.5118 46.6667 54.3333 46.6667Z",
    fill: "#002766",
    stroke: "#002766",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 46.6666H38.6667V23.3333C38.6667 22.6742 38.8041 22.1778 39.0517 21.8586C39.2756 21.5701 39.6617 21.3333 40.4 21.3333H41.6C42.3383 21.3333 42.7244 21.5701 42.9483 21.8586C43.1959 22.1778 43.3333 22.6742 43.3333 23.3333V46.6666Z",
    fill: "#002766",
    stroke: "#002766",
    strokeWidth: 1.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.6667 46.6666H29.6667V31.3333C29.6667 30.6618 29.792 30.1524 30.0155 29.8284C30.2099 29.5465 30.5258 29.3333 31.1333 29.3333H32.2C32.8075 29.3333 33.1234 29.5465 33.3179 29.8284C33.5413 30.1524 33.6667 30.6618 33.6667 31.3333V46.6666Z",
    fill: "#002766",
    stroke: "#002766",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.3333 46.6667H48.3333V38C48.3333 37.3286 48.4587 36.8192 48.6821 36.4952C48.8766 36.2132 49.1925 36 49.8 36H50.8667C51.4742 36 51.79 36.2132 51.9845 36.4952C52.208 36.8192 52.3333 37.3286 52.3333 38V46.6667Z",
    fill: "#002766",
    stroke: "#002766",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup335762);
export default __webpack_public_path__ + "static/media/Group 335762.97a8df304fddbf128c07f8724c8f31bd.svg";
export { ForwardRef as ReactComponent };